
const setStorage = (target) =>
Object.keys(target).forEach((key) => {
  const value = target[key]
  if (value) {
    mpx.setStorageSync(key, value)
  } else {
    mpx.removeStorageSync(key)
  }
})

export default {
  update(state, { phone, token }) {
    state.loged = true
    state.userInfo = { phone, token }
    state.token = token
    setStorage('userInfo',{ phone, token })
    setStorage('token',token)
    accept({
      userInfo:{ phone, token },
      token
    })
    flush()
  }
}
